const list_61 = {
    "DOCUMENTOS COMUNES A TODA SOLICITUD": [ 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534] 
}

const list_62 = {
    "DOCUMENTOS LICENCIA DE URBANIZACION": [ 601, 602, 621, 622, 623, 624, 625, 626, 627 ]
}

const list_63 = {
    "DOCUMENTOS LICENCIA DE PARCELACION": [ 602, 630, 631, 632, 633, 634, 635, 636 ]
}

const list_64 = {
    "DOCUMENTOS ADICIONALES LICENCIA DE SUBDIVISION": [ 641, 642, 643 ]
}


const list_65 = {
    "DOCUMENTOS ADICIONALES DE RECONOCIMIENTO DE EDIFICACIONES": [ 651, 652, 653 ]
}

const list_66 = {
    "DOCUMENTOS ADICIONALES LICENCIA DE CONSTRUCCION": [ 6601, 6602, 6603, 6604, 6605, 6607, 6608, 6609, 6610, 6611, 6612, 6613, 6614, 6615, 6616, 6617, 6618, 6619, 900, 901, 902, 903, 904, 905, 906, 907, 908, 909, 910, 911, 912, 913, 914, 915 ]
}

const list_67 = {
    "DOCUMENTOS INERVENCION Y OCUPACION ESPACIO PUBLICO": [ 671, 672 ]
}

const list_68 = {
    "DOCUMENTOS ADICIONALES OTRAS ACTUACIONES": [ 680, 681, 683, 684, 685, 686, 687, 688, 689, 6891, 6892, 6893 ]
}


const list_Z = {
    "DOCUMENTOS EXPENSAS / IMPUESTOS": [ 701, 712, 702, 711, 703, 705, 706, 707]
}

export var Lists = {
    list_61,
    list_62,
    list_63,
    list_64,
    list_65,
    list_66,
    list_67,
    list_68, 
    list_Z
}
